import { newContract, updateContract } from 'redux/actions/contract';
import {
	resetContractToCurrentFormAsync,
	validateContractForm,
} from '../../lib/services/mobivers/contract';
import { AppStore, SalesType, DispatchThunkAny } from '../../types/redux';

export const CONTRACT_WIZARD_NEW = 'CONTRACT_WIZARD_NEW';
const newContractWizard = (salesType: SalesType) => ({
	type: CONTRACT_WIZARD_NEW,
	payload: salesType,
});

export const CONTRACT_WIZARD_NEXT_STEP = 'CONTRACT_WIZARD_NEXT_STEP';
const contractWizardNextStep = () => ({ type: CONTRACT_WIZARD_NEXT_STEP });

export const CONTRACT_WIZARD_CONTINUE = 'CONTRACT_WIZARD_CONTINUE';
const contractWizardContinue = () => ({ type: CONTRACT_WIZARD_CONTINUE });

export const CONTRACT_WIZARD_CONTINUE_ERROR = 'CONTRACT_WIZARD_CONTINUE_ERROR';
const setContractWizardContinueError = (error: any) => ({
	type: CONTRACT_WIZARD_CONTINUE_ERROR,
	payload: error,
});

export const CONTRACT_WIZARD_RESET_TO_STEP = 'CONTRACT_WIZARD_RESET_TO_STEP';
export const CONTRACT_WIZARD_RESET_TO_STEP_DONE = 'CONTRACT_WIZARD_RESET_TO_STEP_DONE';
export const CONTRACT_WIZARD_PREVIOUS_FORM = 'CONTRACT_WIZARD_PREVIOUS_FORM';

export function newWizard(
	salesType: SalesType
): (dispatch: DispatchThunkAny) => void {
	return (dispatch: DispatchThunkAny) => {
		dispatch(newContractWizard(salesType));
		dispatch(newContract(salesType));
	};
}

export function continueContractAsync(
	data: any
): (dispatch: DispatchThunkAny, getState: any) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		const store: AppStore = { dispatch, getState };
		try {
			dispatch(contractWizardContinue());
			dispatch(updateContract(data));
			const contractData = await validateContractForm(store);
			dispatch(updateContract(contractData));
			dispatch(contractWizardNextStep());
		} catch (error) {
			dispatch(setContractWizardContinueError(error));
			return error;
		}
	};
}

export function goPreviousFormAsync(): (
	dispatch: DispatchThunkAny,
	getState: any
) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		const store: AppStore = { dispatch, getState };
		try {
			dispatch({ type: CONTRACT_WIZARD_PREVIOUS_FORM });
			await resetContractToCurrentFormAsync(store);
			dispatch({ type: CONTRACT_WIZARD_RESET_TO_STEP_DONE });
		} catch (error) {
			dispatch(setContractWizardContinueError(error));
			return error;
		}
	};
}

export function resetContractToStepAsync(
	step: number
): (dispatch: DispatchThunkAny, getState: any) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		const store: AppStore = { dispatch, getState };
		try {
			dispatch({ type: CONTRACT_WIZARD_RESET_TO_STEP, payload: step });
			await resetContractToCurrentFormAsync(store);
			dispatch({ type: CONTRACT_WIZARD_RESET_TO_STEP_DONE });
		} catch (error) {
			dispatch(setContractWizardContinueError(error));
			return error;
		}
	};
}
